import { ApolloError } from '@apollo/client';
import { GraphQLError, GraphQLFormattedError } from 'graphql';

import { ErrorCode } from '@/lib/apollo/types/gen/graphql';

export const getLastError = (
  error?: ApolloError,
): GraphQLFormattedError | GraphQLError | undefined => {
  return error
    ? error.graphQLErrors[error.graphQLErrors.length - 1]
    : undefined;
};

export const getErrorCode = (
  graphQLError?: GraphQLFormattedError | GraphQLError,
): ErrorCode | undefined => {
  if (graphQLError?.extensions?.code) {
    const code = graphQLError?.extensions?.code;
    if (typeof code === 'string' && code in ErrorCode) {
      return graphQLError.extensions.code as ErrorCode;
    }
  }
  return undefined;
};
